import { z } from "zod";
import { countryCodes } from "../../shared/country.js";
import { usStateCodes } from "../../shared/state.js";

const AddressType = z.enum(["businessAddress"]);

export const Request = z.object({
  entityId: z.string(),
  addressType: AddressType,
  line1: z.string().min(1),
  line2: z.string().nullable().optional(),
  line3: z.string().nullable().optional(),
  town: z.string().min(1),
  state: usStateCodes.nullable().optional(),
  postCode: z.string().min(1),
  country: countryCodes,
});

export type Request = z.infer<typeof Request>;
